import React from 'react';

// import { IoIosArrowUp } from "react-icons/io";
import { ArrowIcon } from '../../../utils/icons';

function Sorting({
  draftOrders,
  sortBy,
  sortDir,
  sortOptions,
  onSortChange,
  onOrderRemoved,
  showModal,
  filterBy,
  filterOptions,
  onFilterChange,
}) {
  return (
  <>
  <div className="draft-orders-sort-container">
   


    <div className="draft-orders-filter" >
      <label htmlFor="filter-by">Filter:</label>
      <div className="select-wrapper select-wrapper--primary">
        <ArrowIcon />
        <select id="filter-by" className="button--filter-by" value={filterBy} onChange={(e) => onFilterChange(e.target.value)}>
          {filterOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    </div>


    <div className="draft-orders-sort" >
      <label htmlFor="sort-by" className="sort-by-label">Sort:</label>
      <div className="select-wrapper select-wrapper--primary">
        <ArrowIcon />
        <select
          // onChange={(e) => onSortChange(e.target.value)}
          id="sort-by"
          className="button--sort-by"
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
        >
          {sortOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      
      <div className={`select-wrapper select-wrapper--primary ${sortDir === 'asc' ? 'icon--arrow-up' : 'icon--arrow-down'}`}>
        <ArrowIcon />
        <button
          type="button"
          className={`button--sort`}
          onClick={() => onSortChange(sortBy)}
          title={sortDir === 'asc' ? 'Switch to Descending' : 'Switch to Ascending'}
        >
          {sortDir === 'asc' ? 'Asc' : 'Desc'}
        </button>
      </div>
    </div>
  </div>
  
  </>

  )
}

export default Sorting;